import request from '@/utils/request'
import {ADMIN_URL,ADMIN_SERVICE_URL,AUTH_URL} from '@/utils/constant'
export function login(data) {
  return request({
    url: `${AUTH_URL}/oauth/token`,
    method: 'post',
    params:{
      ...data,
      client_id:'social-trip-admin',
      client_secret:123456,
      grant_type:'password'
    }
  })
}

export function doAuth(data) {
  return request({
    url: `${ADMIN_URL}/dorealauth`,
    method: 'post',
    params:data
  })
}
export function doAuthBatch(recordIds) {
  return request({
    url: `${ADMIN_URL}/updateUserAuthStatusBatch/${recordIds}`,
    method: 'post',
  })
}


export function doVideoCheck(data) {
  return request({
    url: `${ADMIN_URL}/dovideocheck`,
    method: 'post',
    params:data
  })
}

export function getInfo(token) {
  return request({
    url: `${ADMIN_SERVICE_URL}/users/me`,
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: `${AUTH_URL}/oauth/logout`,
    method: 'post'
  })
}

export const getUserInfo = (params) => {
  return request({
    url: `${ADMIN_URL}/getuserinfo`,
    method: 'post',
    params
  })
}

export const searchUserList = (current, size, params) => {
  return request({
    url: `${ADMIN_URL}/searchuserlist`,
    method: 'post',
    params: {
      ...params,
      page:current,
      limit:size
    }
  })
}

export const getVideoCheckList = (current, size, params) => {
  return request({
    url: `${ADMIN_URL}/getvideochecklist`,
    method: 'post',
    params: {
      ...params,
      page:current,
      limit:size
    }
  })
}

export const searchAuthList = (current, size, params) => {
  return request({
    url: `${ADMIN_URL}/getauthlist`,
    method: 'post',
    params: {
      ...params,
      page:current,
      limit:size
    }
  })
}

export function getUserAlbum(params) {
  return request({
    url: `${ADMIN_URL}/getuseralbum`,
    method: 'get',
    params
  })
}

export function deleteUserAlbum(params) {
  return request({
    url: `${ADMIN_URL}/deluserphoto`,
    method: 'post',
    params
  })
}
export function saveUserPhoto(params) {
  return request({
    url: `${ADMIN_URL}/saveuserphoto`,
    method: 'post',
    params
  })
}
export function updateUserStatus(data) {
  return request({
    url: `${ADMIN_URL}/frozenUser`,
    method: 'post',
    params:data
  })
}

export function saveQuestion(params) {
  return request({
    url: `${ADMIN_URL}/saveQuestion`,
    method: 'post',
    params
  })
}
export function getQuestion(userId) {
  return request({
    url: `${ADMIN_URL}/getQuestion?userId=`+userId,
    method: 'get',
  })
}

export function getquestionlist() {
  return request({
    url: `${ADMIN_URL}/getquestionlist`,
    method: 'get',
  })
}

export function deleteQuestion(id) {
  return request({
    url: `${ADMIN_URL}/deleteQuestion?id=`+id,
    method: 'post',
  })
}

//查询用户国家
export function initCountries(userId) {
  return request({
    url: `${ADMIN_URL}/initCountries?userId=`+userId,
    method: 'get',
  })
}
//查询用户城市
export function initCities(userId) {
  return request({
    url: `${ADMIN_URL}/initCities?userId=`+userId,
    method: 'get',
  })
}
//保存国家
export function saveCountries(params) {
  return request({
    url: `${ADMIN_URL}/saveCountries`,
    method: 'post',
    params
  })
}

//保存城市
export function saveCities(params) {
  return request({
    url: `${ADMIN_URL}/saveCities`,
    method: 'post',
    params
  })
}


export function deleteCountries(id) {
  return request({
    url: `${ADMIN_URL}/deleteCountries?id=`+id,
    method: 'post',
  })
}

export function deleteCities(id) {
  return request({
    url: `${ADMIN_URL}/deleteCities?id=`+id,
    method: 'post',
  })
}
